import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { IconButton, Paper } from '@mui/material';
import { DragIndicator } from '@mui/icons-material';

const SortableItem = ({ id, children, disabled = false }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <Paper
        elevation={isDragging ? 4 : 1}
        sx={{
          padding: 2,
          marginBottom: 2,
          position: 'relative',
          cursor: disabled ? 'default' : 'grab',
          '&:hover': {
            elevation: 2,
          },
        }}
      >
        {!disabled && (
          <IconButton
            {...attributes}
            {...listeners}
            size="small"
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              cursor: 'grab',
              '&:active': {
                cursor: 'grabbing',
              },
            }}
          >
            <DragIndicator />
          </IconButton>
        )}
        {children}
      </Paper>
    </div>
  );
};

export default SortableItem;
export { SortableItem };
